export function slug(name: string) {
    return encodeURIComponent(
        name
            .toLowerCase()
            .replace(/^[^a-z]+|[^a-z]+$/g, '')
            .replace(/[^a-z]+/g, '-')
    );
}
